import { CHART_WIDGET_MODE } from '../../../model/enums';

/** description de la configuration d'un chart */
export class ChartDecriptionObj {
  public code: CHART_WIDGET_MODE;
  public label: string; // nom de la série, utilisé pour la légende
  public series: number = 0; // le nombre de séries, 0 = illimité
  public linearAxe: number = 0; // nécessite un axe linéaire, si > 0
  public paramMap: Map<string, any> = null; // les paramètres pour ce type de chart

  constructor(code: CHART_WIDGET_MODE, series = 0, linearAxe = 0, params: string[]) {
    this.code = code;
    this.series = series;
    this.linearAxe = linearAxe;
    this.paramMap = new Map(params.map((item) => [item, null]));
    this.buildLabel();
  }

  /** constuction du label, TODO avec trad */
  private buildLabel(): void {
    this.label = this.code;
  }
}
